import React from 'react'
import './Faq.scss';
import Accordion from 'react-bootstrap/Accordion'

function Faq() {
    return (
        <div id="faq">
            <h1>Frequently asked questions.</h1> 
                <Accordion>
                    <Accordion.Item eventKey="0">
                        <Accordion.Header>What is included in my capncovers subscription?</Accordion.Header>
                        <Accordion.Body>
                        Depending on what plan you subscribe to, you will receive the capncovers team’s best picks for that specific plan. Picks could vary day to day depending on that day’s slate and games we find most appealing. Picks will be mixed from all sports NFL, NHL, NBA, NCAAF, NCAAB, MLB, Boxing, Soccer and MMA  and will include in-depth analysis as to why we like those specified games. 
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="1">
                        <Accordion.Header>Can I make wagers with/on the capncovers website?</Accordion.Header>
                        <Accordion.Body>
                        No, We are not a Sportsbook. We provide elite handicapping advice/picks. In addition, we provide betting odds, and free picks. 
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="2">
                        <Accordion.Header>How much should I bet on a game? </Accordion.Header>
                        <Accordion.Body>
                        This is an excellent & very common question. Our best advice is to always bet within your budget. Everyone has different budgets and it will always be recommended to stay within it whether you bet $25 a game or $25,000 a game. We also encourage you to understand the true definition of the term “unit” as it varies from person to person. 
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="3">
                        <Accordion.Header>Does capncovers win every game they pick? </Accordion.Header>
                        <Accordion.Body>
                        While I wish I could say yes to this question, the fact is we do NOT win every game we pick and if any one person or site claims that they do, they are not being truthful. However, we do win more than we lose and one key to our success is by pacing ourselves. We can absolutely help you build your bankroll as long as you follow our suggestions, which is something we will expand on more as we move forward together. 
                        </Accordion.Body>
                    </Accordion.Item>
                    <Accordion.Item eventKey="4">
                        <Accordion.Header>If I purchase a plan, will capncovers have a specific goal for me? </Accordion.Header>
                        <Accordion.Body>
                        Well, to be honest the easy answer is our goal is to make you money and be 100% satisfied with our services. Which is absolutely true, but at the end of the day you have to have a goal for yourself and remain true to that goal. One of the most common issues with someone who bets is their lack of discipline, and not sticking to a consistent wager amount. A lot of people want to make that quick big buck instead of treating sports wagering the way it should be treated, which is like a marathon. If you treat it like a race, and bet erratically there is a good chance you will not reach your goal. 
                        </Accordion.Body>
                    </Accordion.Item>
                </Accordion>
        </div>
    )
}

export default Faq
